import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const setupMfa = actionCreator(
  actionTypes.RECOVERY_OTPS_REGISTER,
  ({ isFromSettings }) => ({ isFromSettings })
)

export const renewRecoveryCodes = actionCreator(actionTypes.RECOVERY_OTPS_RENEW)

export const recoveryOtpsRegisterSucceeded = actionCreator(
  actionTypes.RECOVERY_OTPS_REGISTER_SUCCEEDED,
  ({ recoveryCodeList }) => ({ recoveryCodeList })
)

export const recoveryOtpsRegisterFailed = actionCreator(
  actionTypes.RECOVERY_OTPS_REGISTER_FAILED,
  ({ errorCode }) => ({ errorCode })
)

export const revokeAllMfaMechanisms = actionCreator(
  actionTypes.REVOKE_ALL_MFA_MECHANISMS,
  ({ password, recaptchaResponse }) => ({ password, recaptchaResponse })
)

export const revokeMfaMechanism = actionCreator(
  actionTypes.REVOKE_MFA_MECHANISM,
  ({ mfaMechanism, password, recaptchaResponse }) => ({
    mfaMechanism,
    password,
    recaptchaResponse
  })
)

export const revokeMfaMechanismSucceeded = actionCreator(
  actionTypes.REVOKE_MFA_MECHANISM_SUCCEEDED,
  ({ mfaMechanism }) => ({ mfaMechanism })
)

export const revokeMfaMechanismFailed = actionCreator(
  actionTypes.REVOKE_MFA_MECHANISM_FAILED,
  ({ errorCode }) => ({ errorCode })
)

export const revokeMfaConfirmationDismissed = actionCreator(
  actionTypes.REVOKE_MFA_CONFIRMATION_DISMISSED
)

export const addMfaMechanismSucceeded = actionCreator(
  actionTypes.ADD_MFA_MECHANISM_SUCCEEDED,
  mfaMechanism => mfaMechanism
)

export const selectMFAToRevoke = actionCreator(
  actionTypes.SELECT_MFA_TO_REVOKE,
  mfaToRevoke => mfaToRevoke
)
